import http from "../../http-common";

class ProductDetailsService {
    getProductDetails(path: string) {
        return http.get(`products/${path}`);
    }
}

export default new ProductDetailsService();
